module.exports = __webpack_public_path__ + "static/media/14.5f49e49a.mp3";